import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useLang } from '../context/LanguageContext';
import { ArrowRight, Phone } from 'lucide-react';
import GetStartedModal from './GetStartedModal';
import CallbackModal from './CallbackModal';

const routeToSource = (pathname) => {
  if (pathname === '/' || pathname === '') return 'home';
  const clean = pathname.replace(/^\//, '').split('/')[0];
  return clean || 'home';
};

const CTASection = ({ serviceName = '' }) => {
  const { t } = useLang();
  const { pathname } = useLocation();
  const source = routeToSource(pathname);
  const [gs, setGs] = useState(false);
  const [cb, setCb] = useState(false);
  return (
    <section className="hero-green text-white">
      <div className="sib-container py-20 text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-5" style={{fontFamily:"'Playfair Display',serif"}}>{t.ctaSection.title}</h2>
        <p className="text-white/85 max-w-2xl mx-auto text-[15.5px] leading-relaxed mb-8">{t.ctaSection.desc}</p>
        <div className="flex flex-wrap gap-4 justify-center">
          <button onClick={() => setGs(true)} className="btn-gold"><ArrowRight size={16} className="rtl-flip" />{t.ctaSection.getStarted}</button>
          <button onClick={() => setCb(true)} className="btn-gold-outline"><Phone size={16} />{t.ctaSection.talkAdvisor}</button>
        </div>
      </div>
      <GetStartedModal open={gs} onClose={() => setGs(false)} pageSource={source} />
      <CallbackModal open={cb} onClose={() => setCb(false)} pageSource={source} serviceName={serviceName} />
    </section>
  );
};

export default CTASection;
